<template lang="pug">
    v-dialog(v-model='dialog' max-width='290')
      template(v-slot:activator='{ on }' )
        v-row    
          v-tooltip(bottom='')
            template(v-slot:activator='{ on }')
              v-btn(color='secondary'  icon :disabled='estado' v-on='on' @click='dialog=true; get(llave)') 
                v-icon(small) fas fa-file-export
            span generar comprobante
      v-card
        v-card-title.headline Datos de comprobantes 
        v-card-text
          v-select( v-model='Datos.tipo_de_comprobante' :items='tipo_de_comprobante' item-text='label' label='Tipo de comprobante' )
          v-row(align='center')
            v-col
              v-text-field( v-model='Datos.serie_comprobante' @change='Datos.serie_comprobante=Datos.serie_comprobante.padStart(4,0)' label='Serie' )
            v-col
              v-text-field(v-model='Datos.numero_comprobante' @change='Datos.numero_comprobante=Datos.numero_comprobante.padStart(9,0)' label='Numero' )
        v-card-actions
          v-spacer  
          v-btn( rounded color='primary' text  @click='generar_entrada(llave); dialog = false') Generar entrada

        

</template>
<script>
import {mapActions, mapGetters, mapState, mapMutations} from 'vuex'
  export default {
    data: ()=>({
      tipo_de_comprobante: [
        {label:'Factura', value: 1 },
        {label:'Boleta', value: 2 },
        {label:'Nota de crédito', value: 3 },
        {label:'Nota de débito', value: 4 },
      ],
      dialog: false,
    }),
    props: {
      llave: String,
      estado : Boolean,
    },
    methods:{ 
      ...mapActions({
      get : 'Ordenes_de_compra/get',
      generar_entrada: 'Ordenes_de_compra/generar_entrada',
      add: 'Ordenes_de_compra/add',
      })
    },
    watch:{
      'Datos.tipo_de_comprobante'(){
        switch(this.Datos.tipo_de_comprobante){
          case 1:
            this.Datos.nombre_de_comprobante = "Factura"
            this.Datos.serie_comprobante = "F001"
            this.Datos.operacion = 'generar_comprobante'
            this.sunat_transaction = 1
            break
          case 2: 
            this.Datos.nombre_de_comprobante = "Boleta"
            this.Datos.serie_comprobante = "B001"
            this.Datos.operacion = 'generar_comprobante'
            this.sunat_transaction = 1
            break
          case 3: 
            this.Datos.nombre_de_comprobante = "Nota de crédito"
            this.Datos.serie_comprobante = "0001"
            this.Datos.operacion = 'generar_comprobante'
            this.sunat_transaction = 1
            break
          case 4: 
            this.Datos.nombre_de_comprobante = "Nota de débito"
            this.Datos.serie_comprobante = "0001"
            this.Datos.operacion = 'generar_comprobante'
            this.sunat_transaction = 1
            break
        }
      },
    },
    computed:{
      ...mapState({
      Datos :state=> state.Ordenes_de_compra.datos,
      Ordenes_de_compra: state=> state.Ordenes_de_compra,
      Customers: state=>state.Customers.data,
      Tipo_de_comprobantes: state=>state.DocumentTypes.data,
      }),
      ...mapGetters({
        Propuestas: 'Ordenes_de_compra/registro',
        Tipo_de_documentos: 'DocumentTypes/record',
      })
    }
    
  }
</script>